import { useMemo } from "react";
import { useUsers } from "@/helpers/hooks";
import { isUserDeleted } from "@/helpers/utils";
import type { BaseUser } from "@/types";

export interface UserOption {
  label: string;
  value: string;
}

export const useExplorerUsersQuery = () => {
  const { users, isLoading } = useUsers(false, true);

  const userList = useMemo((): UserOption[] => {
    if (!users) return [];

    return (users as BaseUser[])
      .filter((user: BaseUser) => user.first_name || user.last_name)
      .map((user: BaseUser) => {
        const fullName = [user.first_name, user.last_name].filter(Boolean).join(" ");
        return {
          label: isUserDeleted(user) ? `${fullName} (deleted)` : fullName,
          value: String(user.id),
        };
      });
  }, [users]);

  const userListWithUnassigned = useMemo((): UserOption[] => {
    return [{ label: "Unassigned", value: "-1" }, ...userList];
  }, [userList]);

  // Filter out deleted users for the filter dropdown
  const activeUserList = useMemo((): UserOption[] => {
    return [
      { label: "Unassigned", value: "-1" },
      ...userList.filter((user: UserOption) => !user.label.includes("(deleted)")),
    ];
  }, [userList]);

  return {
    userList,
    userListWithUnassigned,
    activeUserList,
    isLoading,
  };
};
